import actions from '../../actionTypes';

export default zone => {
  return {
    type: actions.EDITED_ZONE,
    zone
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zones/actions/editedZone.js